import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {Spinkit} from 'ng-http-loader'

@Component({
  selector: 'page-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class PageSignUpComponent implements OnInit, OnDestroy {
  public spinkit = Spinkit
  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    this.document.body.classList.add('register-page');
  }

  ngOnDestroy() {
    this.document.body.classList.remove('register-page');
  }
}
